import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import { LockerListTableOfferComponent, LockerListTableStatus } from '../../../../Types/Application/Ecommerce/LockerList';
import LockerListFilterHeader from './LockerListFilterHeader';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { LockerListTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
import { SVG } from '../../../../AbstractElements';

const LockerListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [LockerListTableDatas, setLockerListTableDatas] = useState<LockerListTableDataColumnType[]>([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  // const [LockerListTableDatas, setLockerListTableDatas] = useState([]);
  const fetchLockers = async (page: number, size: number) => {
    try {
      setLoading(true);

      const response = await api.get(
        `/api/LockerMaster/GetAllLockerPagination?pageNumber=${page}&pageSize=${size}`
      );

      if (response.status === 200) {
        setLockerListTableDatas(
          response.data.items.map((item: { lockerId: any; lockerNumber: any; lockerType: any; lockerPrice: any; securityCharges: any; isLocked: any; }) => ({
            lockerId: item.lockerId,
            lockerNumber: item.lockerNumber,
            lockerType: item.lockerType,
            lockerPrice: item.lockerPrice,
            securityCharges: item.securityCharges === null ? 0 : item.securityCharges,
            isLocked: item.isLocked ? "Active" : "Inactive",
          }))
        );

        // Set total record count from backend
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      console.error("Failed to fetch locker list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLockers(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    try {
      await api.delete(`/api/LockerMaster/DeleteLocker?lockerId=${id}`);
      Swal.fire('Deleted!', 'Locker has been deleted.', 'success');

      // Refresh current page data
      await fetchLockers(currentPage, pageSize);
    } catch (error) {
      Swal.fire('Error!', 'Failed to delete the locker.', 'error');
      console.error("Delete error:", error);
    }
  };

  // Edit

  const handleEdit = (row: any) => {
    setEditData(row);
    setEditModalOpen(true);
  };

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    try {
      if (!editData || !editData.lockerId || !editData.lockerNumber || !editData.lockerType || !editData.lockerPrice || !editData.securityCharges) {
        Swal.fire("Error!", "Please fill all fields before saving.", "error");
        return;
      }
      if (isNaN(Number(editData.lockerPrice)) || Number(editData.lockerPrice) <= 0) {
        Swal.fire("Error!", "Please enter a valid locker price.", "error");
        return;
      }
      if (isNaN(Number(editData.securityCharges)) || Number(editData.securityCharges) < 0) {
        Swal.fire("Error!", "Please enter a valid security charge.", "error");
        return;
      }
      await api.put(`/api/LockerMaster/UpdateLocker`, {
        lockerId: editData.lockerId,
        lockerNumber: editData.lockerNumber,
        lockerType: editData.lockerType,
        lockerPrice: editData.lockerPrice,
        securityCharges: editData.securityCharges,
        isLocked: editData.isLocked === "Active",
      });

      // Refresh current page data
      await fetchLockers(currentPage, pageSize);

      setEditModalOpen(false);
      Swal.fire("Updated!", "The Locker has been updated.", "success");
    } catch (error) {
      Swal.fire("Error!", "Failed to update the Locker.", "error");
    }
  };

  const LockerListTableDataColumn: TableColumn<LockerListTableDataColumnType>[] =
    [
      {
        name: "Locker Number",
        cell: (row) => (
          <LockerListTableOfferComponent title={row.lockerNumber} />
        ),
        sortable: true,
        grow: 2,
        minWidth: '100px',
      },
      {
        name: "Locker Size",
        cell: (row) => (
          <LockerListTableOfferComponent title={row.lockerType} />
        ),
        sortable: true,
        grow: 2,
        minWidth: '100px',
      },
      {
        name: "Locker Price",
        cell: (row) => (
          <LockerListTableOfferComponent title={String(row.lockerPrice)} />
        ),
        sortable: true,
        grow: 2,
        minWidth: '100px',
      },
      {
        name: "Security Charge",
        cell: (row) => (
          <LockerListTableOfferComponent title={String(row.securityCharges)} />
        ),
        sortable: true,
        grow: 2,
        minWidth: '100px',
      },
      {
        name: "Status",
        cell: (row) => (
          <LockerListTableStatus title={row.isLocked} />
        ),
        sortable: true,
        grow: 2,
        minWidth: '100px',
      },
      // {
      //   name: "Action",
      //   cell: (row) => <LockerListTableAction lockerId={row.lockerId} onDelete={handleDelete} />,
      // },
      {
        name: "Action",
        cell: (row) => (
          <div className="d-flex align-items-center gap-2">
            <span
              onClick={() => handleEdit(row)}
              title="Edit"
              style={{ cursor: "pointer" }}
            >
              <SVG
                iconId="edit-content"
                style={{ fill: "blue", width: 18, height: 18 }}
              />
            </span>
            <span
              onClick={() => handleDelete(Number(row.lockerId))}
              title="Delete"
              style={{ cursor: "pointer" }}
            >
              <SVG
                iconId="trash1"
                style={{ fill: "red", width: 18, height: 18 }}
              />
            </span>
          </div>
        ),
      },
    ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };


  const filteredItems = LockerListTableDatas.filter((item) => item.lockerNumber && String(item.lockerNumber).toLowerCase().includes(filterText.toLowerCase()));


  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <LockerListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={LockerListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Locker
        </ModalHeader>
        <ModalBody>
          {editData && (
            <>
              <FormGroup>
                <Label>Locker Number</Label>
                <Input
                  name="lockerNumber"
                  value={editData.lockerNumber}
                  onChange={handleEditChange}
                />
              </FormGroup>

              <FormGroup>
                <Label>Locker Type</Label>
                <Input
                  type="select"
                  name="lockerType"
                  value={editData.lockerType}
                  onChange={handleEditChange}
                >
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                  <option value="Large">Large</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Locker Price</Label>
                <Input
                  name="lockerPrice"
                  value={editData.lockerPrice}
                  onChange={handleEditChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Security Charge</Label>
                <Input
                  name="securityCharges"
                  value={editData.securityCharges}
                  onChange={handleEditChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Status</Label>
                <Input
                  type="select"
                  name="isLocked"
                  value={editData.isLocked}
                  onChange={handleEditChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Input>
              </FormGroup>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleEditSave}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  )
}

export default LockerListContainer